export function attachDownloadFinalStateSync({
  jobId,
  manager,
  dispatch,
  sessionRecord,
  updateDownloadAction,
}) {
  const runPromise = sessionRecord && sessionRecord.runPromise;

  if (
    !jobId ||
    !manager ||
    typeof manager.getDownloadJob !== "function" ||
    typeof dispatch !== "function" ||
    typeof updateDownloadAction !== "function" ||
    !runPromise ||
    typeof runPromise.then !== "function"
  ) {
    return null;
  }

  return Promise.resolve(runPromise)
    .catch((error) => {
      console.warn(error);
    })
    .then(async () => {
      const record = await manager.getDownloadJob({ jobId });
      const job = record && record.job;

      if (job) {
        dispatch(updateDownloadAction(job));
      }

      return job || null;
    })
    .catch((error) => {
      console.warn(error);
      return null;
    });
}
